import { FunctionComponent } from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'
import { OurIntlShape } from '@/i18n/typing'
import { designLayoutSize, PptxObjectType } from '@/utils/export-pptx/constants'
import { ContactSlide } from '@/utils/export-pptx/types/slide'

interface SlideProps {
  slide: ContactSlide
  onSlideReady?: (slide: ContactSlide) => void
  formatMessage: OurIntlShape['formatMessage']
}

const SlideComponent: FunctionComponent<SlideProps> = ({
  slide,
  onSlideReady,
  formatMessage,
}) => {
  useMount(() => {
    onSlideReady?.(slide)
  })

  return (
    <Wrapper>
      <TopBrandLine data-pptx-object={PptxObjectType.Shape} />
      <BottomBrandLine data-pptx-object={PptxObjectType.Shape} />
      <Title data-pptx-object={PptxObjectType.Text}>
        {formatMessage({ id: 'general:pptx_title_contact_us' })}
      </Title>
      <Info>
        {slide.payload.company && (
          <InfoItem>
            <InfoItemTitle data-pptx-object={PptxObjectType.Text}>
              {formatMessage({ id: 'general:field_name_company' })}
            </InfoItemTitle>
            <InfoItemValue data-pptx-object={PptxObjectType.Text}>
              {slide.payload.company}
            </InfoItemValue>
          </InfoItem>
        )}
        {slide.payload.tel && (
          <InfoItem>
            <InfoItemTitle data-pptx-object={PptxObjectType.Text}>
              {formatMessage({ id: 'general:field_name_tel' })}
            </InfoItemTitle>
            <InfoItemValue data-pptx-object={PptxObjectType.Text}>
              {slide.payload.tel}
            </InfoItemValue>
          </InfoItem>
        )}
        {slide.payload.email && (
          <InfoItem>
            <InfoItemTitle data-pptx-object={PptxObjectType.Text}>
              {formatMessage({ id: 'general:field_name_email' })}
            </InfoItemTitle>
            <InfoItemValue data-pptx-object={PptxObjectType.Text}>
              {slide.payload.email}
            </InfoItemValue>
          </InfoItem>
        )}
      </Info>
      <BrandRect data-pptx-object={PptxObjectType.Shape} />
      <Name data-pptx-object={PptxObjectType.Text}>{slide.payload.owner}</Name>
    </Wrapper>
  )
}

const BrandLine = styled.div`
  position: absolute;
  background: ${({ theme }): string => theme.colors.brand.primary};
  height: 1px;
`

const TopBrandLine = styled(BrandLine)`
  top: 72px;
  left: 358px;
  right: 64px;
`

const BottomBrandLine = styled(BrandLine)`
  bottom: 80px;
  left: 64px;
  right: 64px;
`

const InfoItemTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  color: ${({ theme }): string => theme.colors.text.primary};
`

const InfoItemValue = styled.div`
  font-size: 20px;
  line-height: 28px;
`

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Info = styled.div`
  position: absolute;
  top: 296px;
  left: 180px;
  display: flex;
  flex-direction: column;
  gap: 51px;
`

const BrandRect = styled.div`
  position: absolute;
  background: ${({ theme }): string => theme.colors.brand.primary};
  bottom: 80px;
  right: 64px;
  top: 72px;
  width: 482px;
`

const Title = styled.div`
  position: absolute;
  top: 169px;
  left: 173px;
  color: ${({ theme }): string => theme.colors.brand.primary};
  font-size: 64px;
  font-weight: 700;
  line-height: 70px;
  letter-spacing: 0.24em;
`

const Name = styled.div`
  color: ${({ theme }): string => theme.colors.text.white};
  position: absolute;
  bottom: 124px;
  right: 124px;
  font-size: 36px;
  font-weight: 700;
  line-height: 52px;
`

const Wrapper = styled.div`
  font-family: Arial;
  width: ${designLayoutSize.w}px;
  height: ${designLayoutSize.h}px;
  position: relative;
  /* border: solid 1px ${({ theme }): string => theme.colors.text.primary}; */
  color: ${({ theme }): string => theme.colors.text.primary};
  background-color: ${({ theme }): string => theme.colors.border.divider};

  &,
  * {
    box-sizing: border-box;
  }
`

export default SlideComponent
